import {
  API_URL
} from 'api/constants'

export const SEND_INFO_FILE_UPLOADED_CUSTOMERS = `${API_URL}/v1/customers/import_customers_temporary`
export const REQUEST_IMPORT_DATA_TO_CUSTOMERS = `${API_URL}/v1/customers/import_customers`



// WEBPACK FOOTER //
// ./app/api/uploaders/constants.js